import React, {MouseEvent, useCallback} from "react"
import Modal from "./Modal";
import ModalDialogOption from "./ModalDialogOption";
import styles from '../css/Modal.module.css'
import classNames from "classnames";
import Box from "./Box";
import Text from "./Text";
import {toI18N} from "../utils/I18n";
import TextInput from "./TextInput";

export interface Props {
    id: string,
    show?: boolean,
    onDismiss?: (event: MouseEvent) => void,
    onConfirm?: (value: MouseEvent) => void,
    disabled?: boolean,
    words: Array<string>,
    email: string,
    setEmail: (value: string) => void,
}

export default (props: Props) => {

    // Props

    const {id, show, disabled, email, setEmail, words = [], onDismiss, onConfirm} = props;

    // Callbacks

    const handleOnConfirm = useCallback(
        (e) => {
            onConfirm && onConfirm(e)
        },
        [onConfirm],
    );


    return (
        <Modal contentClassName={styles.textModal} round id={id} show={show} center onDismiss={onDismiss}>
            <Box center className={styles.modalTextAreaHorizontalPadding}>
                <Text
                    size={16}>{toI18N("following_words_are_harmful")}<Text size={16}
                    fontWeight={600}>{words.map(v => v.toLowerCase()).join(', ')}</Text></Text>
            </Box>
            <Box className={styles.modalDescriptionAreaNoBorder}>
                <Text center={false} size={12}>{toI18N("we_review_and_you_confirm_email")}</Text>
            </Box>

            <Box grow top fullWidth sideMargin topMargin={12} bottomMargin={12}>
                <Box grow top fullWidth sideMargin topMargin={12} bottomMargin={12}>
                    <TextInput
                        inputMode={"email"}
                        autoCapitalize={'off'}
                        autoCorrect={'off'}
                        value={email}
                        onChange={setEmail}
                        placeholder={toI18N("enter_email_input_placeholder")}
                        id={"email-input-modal-confirmation"}/>
                </Box>
            </Box>
            <Box className={styles.modalDescriptionArea}>
                <Text center={false} size={12}>{toI18N("or_remove_harmful_words")}</Text>
            </Box>
            <Box center className={styles.modalTextAreaButtonsHolder}>
                <Box center flex className={classNames(styles.modalTextAreaButtonOK)}>
                    <ModalDialogOption onClick={onDismiss} value={toI18N("edit_button_no_review")}/>
                </Box>
                <Box center flex className={classNames(styles.modalTextAreaButtonOK)}>
                    <ModalDialogOption disabled={disabled} onClick={handleOnConfirm}
                        value={toI18N('continue_button_review')}/>
                </Box>
            </Box>
        </Modal>
    )
}

